import wetvKernel from '@tencent/wetv-kernel';
const test = 'https://teststatic.wetv.vip/tv/sw.js';
const prod = 'https://static.wetv.vip/tv/sw.js';
const build = process.env.NODE_ENV === 'development' ? test : prod;
/* eslint-disable no-undef */
const url = String(IS_ENV) === 'true' ? 'sw.js' : build;
const scope = String(IS_ENV) === 'true' ? '/' : '/tv/';
console.log(IS_ENV, scope, String(IS_ENV), String(IS_ENV) === 'true');
const { ageisReportor } = wetvKernel;
export const registerServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register(
        url,
        {
          scope,
        },
      );
      if (registration.installing) {
        ageisReportor && ageisReportor.reportEvent({
          name: 'sw_register_success', // 埋点名称
          // ext1: channel_Id, // 触发动作
        });
        console.log('Service worker installing');
      } else if (registration.waiting) {
        console.log('Service worker installed');
      } else if (registration.active) {
        console.log('Service worker active');
      }
    } catch (error) {
      console.error(`Registration failed with ${error}`);
    }
  }
};

